import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getCopDocuments = api(async function copDocuments({ codeOfPracticeId }) {
    return query(
        gql`
            query GetCopDocuments($codeOfPracticeId: ID!) {
                copDocuments(codeOfPracticeId: $codeOfPracticeId)
            }
        `,
        { codeOfPracticeId },
        { returns: "copDocuments" }
    )
})
